import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const Leaderboard = ({
  jeu = "velo",
  isOpen,
  onOpen,
  onClose,
  latestScore,
  onRankResolved
}) => {

  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const refs = useRef({});
  const isMobile = window.innerWidth < 600;

  // ============================
  // FETCH
  // ============================
  useEffect(() => {
    if (!isOpen) return;
    
    onOpen?.()
    
    const fetchScores = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await axios.get(
          `${API_URL}/api/highscore/${jeu}?limit=100`
        );
        setScores(res.data);
      } catch (err) {
        console.error(err);
        setError("Erreur chargement");
      } finally {
        setLoading(false);
      }
    };

    fetchScores();
  }, [isOpen, jeu]);

  // ============================
  // 🔥 SCROLL AUTO
  // ============================
  useEffect(() => {
    if (!latestScore || !scores.length) return;

    const target = scores.find(
      s => s._id?.toString() === latestScore?._id?.toString()
    );

    if (!target) return;

    const targetIndex = scores.findIndex(
      s => s._id?.toString() === latestScore?._id?.toString()
    );

    if (targetIndex >= 0) {
      onRankResolved?.(targetIndex + 1);
    }

    const el = refs.current[target._id];

    if (el) {
      requestAnimationFrame(() => {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      });
    }

  }, [scores, latestScore, onRankResolved]);

  // ============================
  // DATE
  // ============================
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getFullYear()).slice(2)}`;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[2000] bg-black/70"
      data-game-ui role="dialog" aria-modal="true" aria-label="Classement des scores">

      <div
        style={{
          width: "95vw",
          maxWidth: 768,
          maxHeight: "85vh",
          display: "flex",
          flexDirection: "column",
          borderRadius: 18,
          overflow: "hidden",
          border: "2px solid #00e5ff",
          boxShadow: `
            0 0 10px #00e5ff,
            0 0 40px #00e5ff,
            inset 0 0 20px rgba(0,229,255,0.2)
          `,
          background: "#0a0a14",
          color: "white"
        }}
      >

        {/* TOP */}
        <div
          style={{
            height: 150,
            flexShrink: 0,
            backgroundImage: "url('/images/fondJeuVeloTitre.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
        />

        {/* HEADER */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "50px 1fr 90px 70px 90px", // 🔥 réduit
            padding: "8px 16px",
            borderBottom: "1px solid rgba(255,255,255,0.2)",
            fontWeight: "bold",
            fontSize: 14,
            background: "rgba(0,0,0,0.6)"
          }}
        >
          <span>#</span>
          <span>Nom</span>
          <span>Pointage</span>
          <span>Niveau</span>
          <span>Date</span>
        </div>

        {/* CENTER */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden", // 🔥 FIX SCROLL HORIZONTAL
            position: "relative",
            backgroundImage: "url('/images/fondJeuVeloCentre.jpg')",
            backgroundRepeat: "repeat-y",
            backgroundSize: "100% auto"
          }}
        >

          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
              pointerEvents: "none"
            }}
          />

          <div style={{ position: "relative", padding: "8px 16px" }}>

            {loading && <p style={{ textAlign: "center" }}>Chargement...</p>}
            {error && <p style={{ textAlign: "center", color: "red" }}>{error}</p>}

            {!loading && !error && scores.map((s, i) => {

              const isPlayerScore =
                s._id?.toString() === latestScore?._id?.toString();

              return (
                <div
                  key={s._id || i}

                  // 🔥 REF POUR SCROLL
                  ref={(el) => {
                    if (el) refs.current[s._id] = el;
                  }}

                  style={{
                    display: "grid",
                    gridTemplateColumns: isMobile  ? "40px 1fr 70px 60px" : "50px 1fr 90px 70px 90px",
                    padding: "6px 0",
                    alignItems: "center",

                    background: isPlayerScore
                      ? "rgba(255,255,0,0.25)"
                      : "transparent",

                    borderRadius: 6,
                    transform: isPlayerScore ? "scale(1.05)" : "scale(1)",
                    transition: "all 0.3s ease",

                    color: isPlayerScore
                      ? "yellow"
                      : (
                          i === 0 ? "gold" :
                          i === 1 ? "silver" :
                          i === 2 ? "#cd7f32" :
                          "white"
                        ),

                    textShadow: isPlayerScore
                      ? "0 0 12px yellow"
                      : "0 0 6px black",

                    fontWeight: isPlayerScore ? "bold" : "normal"
                  }}
                >
                  <span>
                    {i === 0 ? "🥇 1" :
                     i === 1 ? "🥈 2" :
                     i === 2 ? "🥉 3" :
                     i + 1}
                  </span>

                  <span>{s.nom}</span>
                  <span>{s.score}</span>
                  <span>{s.level}</span>
                  {!isMobile && (
                    <span style={{ fontSize: 12 }}>
                      {formatDate(s.createdAt)}
                    </span>
                  )}
                </div>
              );
            })}

          </div>

        </div>

        {/* BOTTOM */}
        <div
            style={{
              height: 150,
              flexShrink: 0,
              backgroundImage: "url('/images/fondJeuVeloBas.jpg')",
              backgroundSize: "contain",      // 🔥 clé
              backgroundRepeat: "no-repeat",  // 🔥 empêche répétition
              backgroundPosition: "center",   // 🔥 centré
              backgroundColor: "#0a0a14",     // 🔥 remplit vide
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
          <button
            onClick={onClose}
            style={{
              padding: "8px 20px",
              borderRadius: 10,
              border: "none",
              background: "#00e5ff",
              color: "black",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Fermer
          </button>
        </div>

      </div>
    </div>
  );
};

export default Leaderboard;
